// import { CKEditor } from '@tinymce/tinymce-react';
// import { SourceEditing } from '@ckeditor/ckeditor5-source-editing';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AddIcon from '@mui/icons-material/Add';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import DeliveryMethodPreviewDialog from './DeliveryMethodPreviewDialog';
import { Autocomplete, Button, Checkbox, Chip, CircularProgress, Divider, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, LinearProgress, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Select, TextField, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Editor } from 'codemirror';
import MaterialUiPhoneNumber from 'material-ui-phone-number';
import { useSnackbar } from 'notistack';
import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import { Prompt, useHistory, useParams } from 'react-router';

import { CREATE, DataAPIContext, GET_ONE, UPDATE } from '../api';
import AccessDeniedView from '../components/AccessDeniedView';
import { CodeEditor, getCodeEditorValue, insertTextAtCursor, setCodeEditorValue, updateKeysAndMacros } from '../components/CodeEditor';
import FileActionRow from '../components/FileActionRow';
import FixedLinearProgress from '../components/FixedLinearProgress';
import FormActionButtons from '../components/FormActionButtons';
import FormLicenseeContext, { toLicenseeId } from '../components/FormLicenseeContext';
import HTMLPReviewPopper from '../components/HTMLPreviewPopper';
import NavigateBackBar from '../components/NavigateBackBar';
import PageMeta from '../components/PageMeta';
import RecordDetails, { RecordDetailsContext } from '../components/RecordDetails';
import RemoteAutocomplete from '../components/RemoteAutocomplete';
import { Drawer } from '@mui/material';
import SchemaUI from '../components/SchemaUI';
import { ContextStore } from '../store/contextStore';
import { copyTextToClipboard } from '../utils';
import { useIsWidthUp } from '../utils';
import fileToSha1String from '../utils/file_to_sha1';
import NotificationLoading from './NotificationLoading';
import { chatDestinationHtmlOptions, chatOriginHtmlOptions, DELIVERY_METHOD_CHAT, DELIVERY_METHOD_EMAIL, DELIVERY_METHOD_SMS, DELIVERY_METHOD_WHATSAPP, DELIVERY_METHOD_AIRBNB, DELIVERY_METHODS, EMAIL_TO_ADDRESS, EMAIL_TO_SUPPORT, emailDestinationHtmlOptions, SMS_TO_NUMBER, SMS_TO_SUPPORT, smsDestinationHtmlOptions, WHATSAPP_TO_NUMBER, WHATSAPP_TO_SUPPORT, whatsappDestinationHtmlOptions, AIRBNB_TO_ARBITRARY_THREAD_ID, airbnbDestinationHtmlOptions } from './utils';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
    },
    gridRoot: {
        padding: 0,
        [theme.breakpoints.down('sm')]: {
            marginTop: '1rem',
        },
    },
    innerRoot: {
        maxHeight: `calc(${theme.cp.contentHeight} - 45px)`,
        border: 'solid 1px #D8D8D8',
        borderRadius: '12px',
        padding: '0',
        overflow: 'auto',

        [theme.breakpoints.down('sm')]: {
            maxHeight: `calc(${theme.cp.contentHeight} - 3rem - 55px)`,
            overflow: 'auto',
        },
    },
}));

const compare = (a: any, b: any) => {
    if (a.sequence < b.sequence) {
        return -1;
    }
    if (a.sequence > b.sequence) {
        return 1;
    }
    return 0;
};

export const DeliveryMethodEditForm = (props: any) => {
    const dataAPI = React.useContext(DataAPIContext);
    const resource = 'notification';
    const urlParams = useParams();
    const { user, tourOperator, hasPerm, isFranchise, licensees } = React.useContext(ContextStore);
    const hasWritePerm = hasPerm(resource, 'write')

    const notification = props.data;
    // The notification owns the licensee; this screen inherits it and never edits it.
    // The context still feeds any descendant picker that scopes on franchise_to.
    const notificationLicenseeId = toLicenseeId(notification.tour_operator);
    const notificationLicenseeName =
        (typeof notification.tour_operator === 'object' && notification.tour_operator?.name)
        || licensees.find((l: any) => l.id === notificationLicenseeId)?.name
        || (notificationLicenseeId === tourOperator?.id ? tourOperator?.name : null);
    const notificationLicenseeLabel = notificationLicenseeName
        ? `${notificationLicenseeName}${notificationLicenseeId === tourOperator?.id ? ' (parent operator)' : ''}`
        : null;

    const getOptions = () => {
        let options = emailDestinationHtmlOptions;
        if (notification.event && notification.event.startsWith('tour_departure.')) {
            options = options.filter((option: any) => option.key === String(EMAIL_TO_ADDRESS));
        }
        return options;
    }


    const classes = useStyles();
    const [syncActive, setSyncActive] = React.useState(false);
    const [isFormatting, setIsFormatting] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [deliveryMethod , setDeliveryMethod] = React.useState(props.data.delivery_methods.filter((dm: any) => dm.id === parseInt(urlParams.delivery_method_id))[0]);
    const isSmallScreen = !useIsWidthUp('sm');
    // const [showEmailSignature, setShowEmailSignature] = React.useState(deliveryMethod.email_signature ? true : false);
    const [testEmail, setTestEmail] = React.useState({
        email_address: user.email,
        id: deliveryMethod.id,
        reply_to: deliveryMethod.email_replyto,
        context: JSON.stringify({
            example: {
                name: 'example_name',
                email: 'example@email.com',
            },
        }),
    });
    const [showTestEmailDetails, setShowTestEmailDetails] = React.useState(false);
    const [testRenderOpen, setTestRenderOpen] = React.useState(false);
    const delivery_method_type = DELIVERY_METHODS[deliveryMethod.method];
    const tour_operator = tourOperator;
    const [isChanged, setIsChanged] = React.useState(false);

    const history = useHistory();

    const [tagDictionary, setTagDictionary] = React.useState({});
    const [fetchingSchema, setFetchingSchema] = React.useState({});

    const [showTestEmailWarning, setTestEmailWarning] = React.useState(false);

    const [cm, setCm] = React.useState<Editor>();

    const onCheckboxChange = (name: any, ev: any) => {
        setDeliveryMethod((prevState: any) => ({
            ...prevState,
            [name]: !prevState[name],
        }));
    };

    const [emailSubject, setEmailSubject] = React.useState(deliveryMethod.email_subject || '');
    const [emailReplyTo, setEmailReplyTo] = React.useState(deliveryMethod.email_replyto || '');
    const [emailAddress, setEmailAddress] = React.useState(deliveryMethod.email_address || '');

    const onEmailSubjectChange = (e: any) => {
        setEmailSubject(e.target.value.trim());
    };

    const onEmailReplyToChange = (e: any) => {
        setEmailReplyTo(e.target.value.trim());
    };

    const onEmailAddressChange = (e: any) => {
        setEmailAddress(e.target.value.trim());
    };

    React.useEffect(() => {
        setIsChanged(true);
    }, [deliveryMethod, emailSubject, emailReplyTo, emailAddress]);   
    
    React.useEffect(() => {
        setIsChanged(false); // 
    },[]);

    const handleSave = () => {
        var data = getCodeEditorValue(cm);
        var deliveryMethodFinal = ({ 
            ...deliveryMethod, 
            [messageField]: data, 
            email_subject: emailSubject, 
            email_replyto: emailReplyTo, 
            email_address: emailAddress, 
            _changed: true 
        });
        const saveData = { 
            id: urlParams.id, 
            data: 
            { ...props.data, 
                attachments: [...emailAttachments], 
                delivery_methods: 
                [...props.data.delivery_methods.filter((dm: any) => 
                    dm.id !== deliveryMethodFinal.id), 
                    deliveryMethodFinal].sort(compare) 
                } 
            };
        // if (deliveryMethod?.email_attach_notification_files && (props.data?.attachments?.length === 0 && emailAttachments.length === 0)) {
        // email_attach_notification_files defaults to true on every delivery method (incl. WhatsApp/SMS),
        // so this "attach notification files but no attachments" guard must only apply to EMAIL methods --
        // otherwise a WhatsApp/SMS method with no email attachments is wrongly blocked from saving.
        if (deliveryMethod?.method === DELIVERY_METHOD_EMAIL && deliveryMethod?.email_attach_notification_files && emailAttachments.length === 0) {
            enqueueSnackbar('Delivery method update failed, Other was checked but no file attachments were provided', { variant: 'error', autoHideDuration: 4000 });
            return;
        }
        setSyncActive(true);
        (async () => {
            try {
                const res = await dataAPI(UPDATE, resource, saveData);
                if (res.statusCode === 200) {
                    enqueueSnackbar('Delivery method updated', { variant: 'success' });
                    setTestEmailWarning(false);
                    setIsChanged(false);
                } else if (res.statusCode === 406) {
                    enqueueSnackbar('Delivery method validation error', { variant: 'warning' });
                }
            } finally {
                setSyncActive(false);
            }
        })();
    };

    const handleCopyTagTemplate = (text: any) => {
        if (text) {
            copyTextToClipboard(text);
            insertTextAtCursor(cm!, text);
            enqueueSnackbar(`Tag copied!`, { variant: 'success', autoHideDuration: 500 });
            cm?.focus();
        } else {
            enqueueSnackbar('Cannot copy empty tag!', { variant: 'error', autoHideDuration: 500 });
        }
    };

    const onSendTestEmailChange = () => {
        setShowTestEmailDetails((prev) => {
            if (!prev) {
                setTestEmail((prevState) => ({ ...prevState, email_address: prevState.email_address || user.email }));
            }
            return !prev;
        });
    };

    const handleSendTestEmail = () => {
        if (isChanged) {
            setTestEmailWarning(true);
            return;
        }
        setSyncActive(true);
        (async () => {
            try {
                const res = await dataAPI(UPDATE, resource, { id: urlParams.id, data: { ...testEmail, context: JSON.parse(testEmail.context) }, urlSuffix: 'test/' });
                if (res && res.statusCode === 200) {
                    enqueueSnackbar('Test email was sent successfully. Please check you email.', { variant: 'success' });
                } else {
                    enqueueSnackbar('Test email send failed', { variant: 'error' });
                }
            } finally {
                setSyncActive(false);
            }
        })();
    };

    React.useEffect(() => {
        // Render the selected email signature
        if (deliveryMethod.email_signature) {
            document!.getElementById('display_signature')!.innerHTML = deliveryMethod.email_signature.text;
        }
    }, []);

    React.useEffect(() => {
        const fetchNotificationJsonSchema = () => {
            setFetchingSchema(true);
            (async () => {
                try {
                    const res = await dataAPI(GET_ONE, resource, {
                        urlSuffix: `event/`,
                        filter: { type: props.data.event },
                    });
                    if (res.statusCode === 200) {
                        await setTagDictionary(res.data);
                        var keyCount = updateKeysAndMacros(res.data);
                        await setTagDictionaryPropertyCount(keyCount);
                    }
                } catch (e) {
                    console.log('error fetching json schema', e);
                }
                setFetchingSchema(false);
            })();
        };
        fetchNotificationJsonSchema();
    }, []);

    const [tagDictionaryPropertyCount, setTagDictionaryPropertyCount] = React.useState(0);

    //Phone input server validation
    const [phoneServerCheck, setPhoneServerCheck] = React.useState(false);
    const [phoneServerCheckError, setPhoneServerCheckError] = React.useState(false);
    // CP-6601: kept out of deliveryMethod, where any change marks the form dirty -- a blur
    // alone used to raise the leave prompt.
    const [phoneBlurred, setPhoneBlurred] = React.useState(false);

    const testIfAreaCode = (area_code: any) => {
        let res = /^(\+?\d{1,3}|\d{1,4})$/;
        if (area_code === '+' || !area_code) {
            setPhoneServerCheckError(true);
        }
        if (res.test(area_code)) {
            setPhoneServerCheckError(true);
        }
    };

    const phoneNumberServerCheck = async () => {
        // A WhatsApp method can hold only whatsapp_number; validating sms_number there sent null.
        const phone = deliveryMethod.method === DELIVERY_METHOD_WHATSAPP ? deliveryMethod.whatsapp_number : deliveryMethod.sms_number;
        const params = {
            data: { phone },
        };
        if (phone) {
            setPhoneServerCheck(true);
            await dataAPI(CREATE, 'user/validate_phone', params)
                .then((res: any) => {
                    if (res.data && !res.data.status) {
                        setPhoneServerCheckError(true);
                    } else {
                        setPhoneServerCheckError(false);
                    }
                })
                .finally(() => {
                    setPhoneServerCheck(false);
                });
        }
    };

    React.useEffect(() => {
        if (
            !phoneBlurred ||
            deliveryMethod.method !== DELIVERY_METHOD_SMS ||
            (deliveryMethod.method === DELIVERY_METHOD_SMS && deliveryMethod.sms_destination !== SMS_TO_NUMBER) ||
            deliveryMethod.method !== DELIVERY_METHOD_WHATSAPP ||
            (deliveryMethod.method === DELIVERY_METHOD_WHATSAPP && deliveryMethod.whatsapp_destination !== WHATSAPP_TO_NUMBER)
        ) {
            return;
        }
        const tm = setTimeout(async () => {
            phoneNumberServerCheck();
        }, 1000);
        return () => {
            clearTimeout(tm);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deliveryMethod.sms_number, deliveryMethod.whatsapp_number]);

    const handleOnPhoneBlur = (ev: any) => {
        testIfAreaCode(ev.target.value);
        phoneNumberServerCheck();
        setPhoneBlurred(true);
    };

    const handleOnPhoneChange = (number: any) => {
        setDeliveryMethod((prevState: any) => ({ ...prevState, sms_number: number, whatsapp_number: number }));
    };

    const handleOnAirbnbThreadIDChange = (ev: any) => {
        setDeliveryMethod((prevState: any) => ({ ...prevState, airbnb_thread_id: ev.target.value }));
    };

    const onDestinationChange = (ev: any) => {
        if (deliveryMethod.method === DELIVERY_METHOD_EMAIL) {
            setDeliveryMethod((prev: any) => ({ ...prev, email_destination: parseInt(ev.target.value) }));
        }
        if (deliveryMethod.method === DELIVERY_METHOD_SMS) {
            if (parseInt(ev.target.value) !== SMS_TO_NUMBER) {
                setPhoneServerCheck(false);
                setPhoneServerCheckError(false);
            }
            setDeliveryMethod((prev: any) => ({ ...prev, sms_destination: parseInt(ev.target.value), sms_number: null }));
        }
        if (deliveryMethod.method === DELIVERY_METHOD_WHATSAPP) {
            if (parseInt(ev.target.value) !== WHATSAPP_TO_NUMBER) {
                setPhoneServerCheck(false);
                setPhoneServerCheckError(false);
            }
            setDeliveryMethod((prev: any) => ({ ...prev, whatsapp_destination: parseInt(ev.target.value), whatsapp_number: null }));
        }
        if (deliveryMethod.method === DELIVERY_METHOD_AIRBNB) {
            setDeliveryMethod((prev: any) => ({ ...prev, airbnb_destination: parseInt(ev.target.value) }));
        }
        if (deliveryMethod.method === DELIVERY_METHOD_CHAT) {
            setDeliveryMethod((prev: any) => ({ ...prev, chat_destination: parseInt(ev.target.value) }));
        }
    };

    const handleSupportDestinationChange = (ev: any, support: any) => {
        if (deliveryMethod.method === DELIVERY_METHOD_EMAIL) {
            if (!support) {
                setDeliveryMethod((prev: any) => ({ ...prev, email_support: null }));
            } else {
                setDeliveryMethod((prev: any) => ({ ...prev, email_support: support }));
            }
        }
        if (deliveryMethod.method === DELIVERY_METHOD_SMS) {
            if (!support) {
                setDeliveryMethod((prev: any) => ({ ...prev, sms_support: null }));
            } else {
                setDeliveryMethod((prev: any) => ({ ...prev, sms_support: support }));
            }
        }
        if (deliveryMethod.method === DELIVERY_METHOD_WHATSAPP) {
            if (!support) {
                setDeliveryMethod((prev: any) => ({ ...prev, whatsapp_support: null }));
            } else {
                setDeliveryMethod((prev: any) => ({ ...prev, whatsapp_support: support }));
            }
        }
    };

    //Attachments handling
    const [emailAttachments, setEmailAttachments] = React.useState(props.data.attachments);

    //File attachments
    const handleFileSave = (emailAttachment: any) => {
        (async () => {
            try {
                const params = {
                    id: urlParams.id,
                    data: { attachment: emailAttachment.file },
                    upload: true,
                };
                setSyncActive(true);
                const res = await dataAPI(UPDATE, resource, params);
                if (res.statusCode === 200) {
                    setEmailAttachments(res.data.attachments);
                    enqueueSnackbar('File Saved', { variant: 'success' });
                } else {
                    enqueueSnackbar('File save failed please refresh the page and try again', { variant: 'warning' });
                }
            } finally {
                setSyncActive(false);
            }
        })();
    };

    // CP-5559: the id of the attachment a Replace icon opened the picker for; null when Add attachment did.
    const replaceAttachmentId = React.useRef<any>(null);

    // One save drops the old file and uploads the new one, so a failed upload never leaves the old one deleted.
    const handleFileReplace = (id: any, file: File) => {
        (async () => {
            try {
                const params = {
                    id: (urlParams as any).id,
                    data: { attachments: emailAttachments.filter((attachment: any) => attachment.id !== id) },
                    files: { attachment: file },
                };
                setSyncActive(true);
                const res = await dataAPI(UPDATE, resource, params);
                if (res.statusCode === 200) {
                    setEmailAttachments(res.data.attachments);
                    enqueueSnackbar('File Replaced', { variant: 'success' });
                } else {
                    enqueueSnackbar('File replace failed please refresh the page and try again', { variant: 'warning' });
                }
            } finally {
                setSyncActive(false);
            }
        })();
    };

    const onDrop = React.useCallback(
        async (acceptedFiles) => {
            if (!acceptedFiles[0]) return;
            let new_attachment = {};
            let hash_string = await fileToSha1String(acceptedFiles[0]);
            const replaceId = replaceAttachmentId.current;
            if (replaceId !== null) {
                if (emailAttachments.some((existing_file: any) => existing_file.id !== replaceId && existing_file.content_hash === hash_string)) {
                    enqueueSnackbar('Duplicate file found, please check existing attachments', { variant: 'default', autoHideDuration: 3000 });
                    return;
                }
                handleFileReplace(replaceId, acceptedFiles[0]);
                return;
            }
            setEmailAttachments((prev: any) => {
                if (prev.filter((existing_file: any) => existing_file.content_hash === hash_string).length > 0) {
                    enqueueSnackbar('Duplicate file found, please check existing attachments', { variant: 'default', autoHideDuration: 3000 });
                    return prev;
                }
                new_attachment = {
                    idx: prev.length,
                    file: acceptedFiles[0],
                    name: acceptedFiles[0].name,
                    content_hash: hash_string,
                };

                return [new_attachment, ...prev];
            });

            handleFileSave(new_attachment);
        },
        [emailAttachments]
    );

    const dz = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxFiles: 1,
        onDrop: onDrop,
        multiple: false,
    });

    const handleFileDelete = (id: any) => {
        let file_attachments = [...emailAttachments];
        file_attachments = file_attachments.filter((attachment) => attachment.id !== id);
        (async () => {
            try {
                const params = {
                    id: urlParams.id,
                    data: { ...props.data, attachments: [...file_attachments] },
                    upload: false,
                };
                setSyncActive(true);
                const res = await dataAPI(UPDATE, resource, params);
                if (res.statusCode === 200) {
                    setEmailAttachments(res.data.attachments);
                    enqueueSnackbar('File Deleted', { variant: 'default' });
                } else {
                    enqueueSnackbar('File delete failed please refresh the page and try again', { variant: 'error' });
                }
            } finally {
                setSyncActive(false);
            }
        })();
    };

    const handleOnReplace = (dz: any, attachmentId: any = null) => {
        replaceAttachmentId.current = attachmentId;
        dz.open();
    };

    const checkAllRequiredFieldsBasedOnDeliveryMethod = () => {
        if (!isChanged) {
            return false;
        }

        if (phoneServerCheck || phoneServerCheckError) {
            return false;
        }

        if (deliveryMethod.method === DELIVERY_METHOD_EMAIL) {
            if (emailSubject === '') {
                return false;
            }
            if (deliveryMethod.email_destination === EMAIL_TO_SUPPORT && !deliveryMethod.email_support) {
                return false;
            }
            if (deliveryMethod.email_destination === EMAIL_TO_ADDRESS && !emailAddress) {
                return false;
            }
        }

        if (deliveryMethod.method === DELIVERY_METHOD_SMS) {
            if (deliveryMethod.sms_destination === SMS_TO_SUPPORT && !deliveryMethod.sms_support) {
                return false;
            }
            if (deliveryMethod.sms_destination === SMS_TO_NUMBER && !deliveryMethod.sms_number) {
                return false;
            }
        }

        if (deliveryMethod.method === DELIVERY_METHOD_WHATSAPP) {
            if (deliveryMethod.whatsapp_destination === WHATSAPP_TO_SUPPORT && !deliveryMethod.whatsapp_support) {
                return false;
            }
        }

        if (deliveryMethod.method === DELIVERY_METHOD_AIRBNB) {
            if (deliveryMethod.airbnb_destination === AIRBNB_TO_ARBITRARY_THREAD_ID && !deliveryMethod.airbnb_thread_id) {
                return false;
            }
        }

        return true;
    };

    const onOriginChange = (ev: any) => {
        setDeliveryMethod((prev: any) => ({ ...prev, chat_origin: parseInt(ev.target.value) }));
    };

    const onChatUserChange = (ev: any, user: any) => {
        setDeliveryMethod((prev: any) => ({ ...prev, chat_origin_user: user }));
    };

    const DELIVERY_METHOD_FIELD_MAP = new Map<number, string>([
        [DELIVERY_METHOD_EMAIL, 'email_message'],
        [DELIVERY_METHOD_SMS, 'sms_message'],
        [DELIVERY_METHOD_CHAT, 'chat_message'],
        [DELIVERY_METHOD_WHATSAPP, 'whatsapp_message'],
        [DELIVERY_METHOD_AIRBNB, 'airbnb_message']
    ]);

    function getDeliveryMethodField(): string {
        return DELIVERY_METHOD_FIELD_MAP.get(deliveryMethod.method);
    }

    let messageField: string;
    switch (+deliveryMethod.method) {
        case DELIVERY_METHOD_EMAIL: messageField = "email_message"; break;
        case DELIVERY_METHOD_SMS: messageField = "sms_message"; break;
        case DELIVERY_METHOD_CHAT: messageField = "chat_message"; break;
        case DELIVERY_METHOD_WHATSAPP: messageField = "whatsapp_message"; break;
        case DELIVERY_METHOD_AIRBNB: messageField = "airbnb_message"; break;
        default:
            console.error("Unexpected delivery method:", deliveryMethod);
            break;
    }

    const onFormatTemplateClick = (ev: any) => {
        setIsFormatting(true);
        const source_tpl = getCodeEditorValue(cm);
        // console.log('sending tpl', messageField, deliveryMethod, source_tpl);
        dataAPI(CREATE, resource, { urlSuffix: 'lint/', data: { template: source_tpl }})
            .then((res: any) => {
                console.log('lint res', messageField, res.data.template);
                setDeliveryMethod((prev: any) => ({ ...prev, [messageField]: res.data.template, _changed: true }));
                // code mirror needs to explicitly call this method to set value
                setCodeEditorValue(cm, res.data.template);
            })
            .finally(() => {
                setIsFormatting(false);
                setIsChanged(true);
            });
    }
    // const [otherCheckbox, setOtherCheckbox] = React.useState(props?.data?.attachments.length > 0);
    const canSave = checkAllRequiredFieldsBasedOnDeliveryMethod();

    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
      setOpen(newOpen);
    };

    return (
        <FormLicenseeContext.Provider value={notificationLicenseeId}>
        <div className={classes.root}>
            <PageMeta title={'Edit Delivery Method'} />
            <Prompt when={isChanged} message="Are you sure you want to leave without saving changes?" />
            <FixedLinearProgress visibility={syncActive} alwaysShow={null} />
            <div className={classes.gridRoot}>
                <Grid container direction="row">
                    <Grid item xs={12} container m={!isSmallScreen ? 2 : 1} className={classes.innerRoot}>
                        <Grid item container xs={12}  alignItems="center">
                            <Grid item xs={9} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <NavigateBackBar label={props.data.name} url={`/notifications/${props.data.id}`} maxLabelLength={isSmallScreen ? 40 : 120} />
                                {/* Read-only: ownership is set on the notification screen and inherited
                                    here. This page is deep-linked, so name which licensee it belongs to. */}
                                {isFranchise && notificationLicenseeLabel && (
                                    <Chip size="small" variant="outlined" label={notificationLicenseeLabel} />
                                )}
                            </Grid>
                            <Grid sx={{right: {marginLeft: 'auto'}, padding: '5px 15px 0px'}}>
                                <Button onClick={() => setTestRenderOpen(true)} variant="outlined" sx={{ marginRight: 1 }}>
                                    <PlayArrowIcon sx={{minWidth: '20px', paddingRight: '5px'}}/>Test Render
                                </Button>
                                <Button onClick={toggleDrawer(true)} variant="outlined"><LocalOfferIcon sx={{minWidth: '20px', paddingRight: '5px'}}/>Tag Dictionary</Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid item xs={12} container alignItems="start">
                            {/* Left side  */}
                            <Grid item xs={12} lg={12} container p={2} mt={0} spacing={2}>
                                {/* Email */}
                                <Grid item xs={12} container justifyContent="space-between">
                                    <Grid item>
                                        <Typography fontSize={20} fontWeight={500}>
                                            Message content:
                                        </Typography>
                                    </Grid>
                                    <Grid item style={{ backgroundColor: '#F5F5F5', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} p={1}>
                                        <Typography fontSize={14} variant="h6">
                                            {DELIVERY_METHODS[deliveryMethod.method]}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && (
                                    <>
                                        <Grid item xs={12} sm={8}>
                                            <TextField disabled={!hasWritePerm} required label="Subject" name="email_subject" defaultValue={emailSubject} variant="filled" fullWidth onChange={onEmailSubjectChange} />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField disabled={!hasWritePerm} name="email_replyto" label="Email reply to:" defaultValue={emailReplyTo} variant="filled" fullWidth onChange={onEmailReplyToChange} />
                                        </Grid>
                                    </>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && (
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth disabled={!hasWritePerm}>
                                            <InputLabel style={{ marginTop: '1rem' }} id="destination">
                                                Destination
                                            </InputLabel>
                                            <Select onChange={onDestinationChange} name="destination" labelId="destination" size="small" variant="filled" native defaultValue={deliveryMethod.email_destination}>
                                                {getOptions()}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && deliveryMethod.email_destination === EMAIL_TO_SUPPORT && (
                                    <Grid item xs={4}>
                                        <Autocomplete
                                        disabled={!hasWritePerm}
                                            getOptionLabel={(option) => option.name}
                                            fullWidth
                                            options={tour_operator.support_contacts}
                                            defaultValue={deliveryMethod.email_support}
                                            onChange={handleSupportDestinationChange}
                                            renderInput={(params) => <TextField required {...params} size="small" label="Support Email Address" variant="filled" />}
                                        />
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && deliveryMethod.email_destination === EMAIL_TO_ADDRESS && (
                                    <Grid item xs={4}>
                                        <TextField disabled={!hasWritePerm} name={'email_address'} defaultValue={emailAddress} variant="filled" label="Arbitrary Email Address" required fullWidth onChange={onEmailAddressChange} size="small" />
                                    </Grid>
                                )}
                                {/* SMS */}
                                {deliveryMethod.method === DELIVERY_METHOD_SMS && (
                                    <Grid item xs={8}>
                                        <FormControl fullWidth disabled={!hasWritePerm}>
                                            <InputLabel style={{ marginTop: '1rem' }} id="destination">
                                                Destination
                                            </InputLabel>
                                            <Select onChange={onDestinationChange} name="destination" labelId="destination" size="small" variant="filled" native defaultValue={deliveryMethod.sms_destination}>
                                                {smsDestinationHtmlOptions}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_SMS && deliveryMethod.sms_destination === SMS_TO_SUPPORT && (
                                    <Grid item xs={4}>
                                        <Autocomplete
                                        disabled={!hasWritePerm}
                                            getOptionLabel={(option) => option.name}
                                            fullWidth
                                            options={tour_operator.support_contacts}
                                            onChange={handleSupportDestinationChange}
                                            defaultValue={deliveryMethod.sms_support}
                                            renderInput={(params) => <TextField required {...params} size="small" label="Support Phone Number" variant="filled" />}
                                        />
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_SMS && deliveryMethod.sms_destination === SMS_TO_NUMBER && (
                                    <Grid item xs={4}>
                                        <Grid item xs={12}>
                                            <MaterialUiPhoneNumber
                                            disabled={!hasWritePerm}
                                                variant="filled"
                                                size="small"
                                                name="sms_number"
                                                label="Arbitrary Phone Number"
                                                fullWidth
                                                autoComplete="off"
                                                defaultCountry="us"
                                                inputProps={{
                                                    name: 'phone',
                                                }}
                                                onChange={handleOnPhoneChange}
                                                onBlur={handleOnPhoneBlur}
                                                // CP-6601: the phone input reads only `value`; a `defaultValue` left the saved number blank.
                                                value={deliveryMethod.sms_number || ''}
                                                InputProps={{
                                                    endAdornment: phoneServerCheck && (
                                                        <InputAdornment position="end">
                                                            <CircularProgress size={20} color="primary" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                helperText={phoneServerCheckError && 'Please enter a valid phone number'}
                                                error={phoneServerCheckError}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                {/* WHATSAPP */}
                                {deliveryMethod.method === DELIVERY_METHOD_WHATSAPP && (
                                    <Grid item xs={8}>
                                        <FormControl fullWidth disabled={!hasWritePerm}>
                                            <InputLabel style={{ marginTop: '1rem' }} id="destination">
                                                Destination
                                            </InputLabel>
                                            <Select onChange={onDestinationChange} name="destination" labelId="destination" size="small" variant="filled" native defaultValue={deliveryMethod.whatsapp_destination}>
                                                {whatsappDestinationHtmlOptions}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_WHATSAPP && deliveryMethod.whatsapp_destination === WHATSAPP_TO_SUPPORT && (
                                    <Grid item xs={4}>
                                        <Autocomplete
                                        disabled={!hasWritePerm}
                                            getOptionLabel={(option) => option.name}
                                            fullWidth
                                            options={tour_operator.support_contacts}
                                            onChange={handleSupportDestinationChange}
                                            defaultValue={deliveryMethod.whatsapp_support}
                                            renderInput={(params) => <TextField required {...params} size="small" label="Support WhatsApp Number" variant="filled" />}
                                        />
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_WHATSAPP && deliveryMethod.whatsapp_destination === WHATSAPP_TO_NUMBER && (
                                    <Grid item xs={4}>
                                        <Grid item xs={12}>
                                            <MaterialUiPhoneNumber
                                            disabled={!hasWritePerm}
                                                variant="filled"
                                                size="small"
                                                name="whatsapp_number"
                                                label="Arbitrary Phone Number"
                                                fullWidth
                                                autoComplete="off"
                                                defaultCountry="us"
                                                inputProps={{
                                                    name: 'phone',
                                                }}
                                                onChange={handleOnPhoneChange}
                                                onBlur={handleOnPhoneBlur}
                                                value={deliveryMethod.whatsapp_number || ''}
                                                InputProps={{
                                                    endAdornment: phoneServerCheck && (
                                                        <InputAdornment position="end">
                                                            <CircularProgress size={20} color="primary" />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                helperText={phoneServerCheckError && 'Please enter a valid phone number'}
                                                error={phoneServerCheckError}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                {/* CP-8382: out of the 24h window, deliver the full message in a marketing template instead of the "View message" opener. */}
                                {deliveryMethod.method === DELIVERY_METHOD_WHATSAPP && (
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            disabled={!hasWritePerm}
                                            control={
                                                <Checkbox
                                                    name="whatsapp_send_as_marketing"
                                                    checked={!!deliveryMethod.whatsapp_send_as_marketing}
                                                    onChange={(ev) => onCheckboxChange('whatsapp_send_as_marketing', ev)}
                                                />
                                            }
                                            label="Send as marketing"
                                        />
                                        <Tooltip title="When the guest hasn't messaged in the last 24 hours, WhatsApp only allows approved templates. By default they get a short 'View message' prompt and must tap it to see this message. With this on, the full message is delivered inside a marketing template instead. Marketing templates are billed at a higher rate, and Meta may limit how many a guest receives or skip guests who opted out of marketing.">
                                            <Typography variant="caption" color="textSecondary" component="span" sx={{ ml: 1 }}>
                                                Guests see the full message without tapping "View message". Billed as marketing.
                                            </Typography>
                                        </Tooltip>
                                    </Grid>
                                )}
                                {/* AIRBNB */}
                                {deliveryMethod.method === DELIVERY_METHOD_AIRBNB && (
                                    <Grid item xs={8}>
                                        <FormControl fullWidth disabled={!hasWritePerm}>
                                            <InputLabel style={{ marginTop: '1rem' }} id="destination">
                                                Destination
                                            </InputLabel>
                                            <Select onChange={onDestinationChange} name="destination" labelId="destination" size="small" variant="filled" native defaultValue={deliveryMethod.airbnb_destination}>
                                                {airbnbDestinationHtmlOptions}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_AIRBNB && deliveryMethod.airbnb_destination === AIRBNB_TO_ARBITRARY_THREAD_ID && (
                                    <Grid item xs={4}>
                                        <Grid item xs={12}>
                                            <TextField
                                            disabled={!hasWritePerm}
                                                variant="filled"
                                                size="small"
                                                label="Thread ID"
                                                fullWidth
                                                onChange={handleOnAirbnbThreadIDChange}
                                                defaultValue={deliveryMethod.airbnb_thread_id || ''}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                                {/* Chat */}
                                {deliveryMethod.method === DELIVERY_METHOD_CHAT && (
                                    <Grid item xs={12} container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth disabled={!hasWritePerm}>
                                                <InputLabel style={{ marginTop: '1rem' }} id="origin-label">
                                                    Chat Message Sender
                                                </InputLabel>
                                                <Select onChange={onOriginChange} name="origin" labelId="origin-label" size="small" variant="filled" native defaultValue={deliveryMethod.chat_origin}>
                                                    {chatOriginHtmlOptions}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {deliveryMethod.chat_origin === 1 && (
                                            <Grid item xs={12} md={6}>
                                                <RemoteAutocomplete
                                                disabled={!hasWritePerm}
                                                    getOptionLabel={(option: any) => option.display_name}
                                                    filterOptions={(options: any, state: any) => options}
                                                    resource="user"
                                                    urlSuffix={null}
                                                    label="Chat Origin User"
                                                    variant="filled"
                                                    size="small"
                                                    onChange={onChatUserChange}
                                                    defaultValue={deliveryMethod.chat_origin_user}
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_CHAT && (
                                    <Grid item xs={6}>
                                        <FormControl fullWidth disabled={!hasWritePerm}>
                                            <InputLabel style={{ marginTop: '1rem' }} id="destination">
                                                Destination
                                            </InputLabel>
                                            <Select onChange={onDestinationChange} name="destination" labelId="destination" size="small" variant="filled" native defaultValue={deliveryMethod.chat_destination}>
                                                {chatDestinationHtmlOptions}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                )}
                                {/* {deliveryMethod.method === DELIVERY_METHOD_CHAT && deliveryMethod.chat_destination === CHAT_TO_ARBITRARY_SID && (
                                    <Grid item xs={6}>
                                        <TextField name={'chat_conversation_sid'} value={deliveryMethod.chat_conversation_sid} variant="filled" label="Arbitrary Conversation SID" fullWidth onChange={onTextChange} size="small" />
                                    </Grid>
                                )} */}
                                {/* CP-8014: no-reply ("prevent replies"). Chat is inherently two-way, so this only applies to non-chat methods. */}
                                {deliveryMethod.method !== DELIVERY_METHOD_CHAT && (
                                    <Grid item xs={12} container spacing={1}>
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                disabled={!hasWritePerm}
                                                control={
                                                    <Checkbox
                                                        name="prevent_replies"
                                                        checked={!!deliveryMethod.prevent_replies}
                                                        onChange={(ev) => onCheckboxChange('prevent_replies', ev)}
                                                    />
                                                }
                                                label="Prevent replies (one-way message)"
                                            />
                                            <Tooltip title="Replies to this message are not routed into chat. The sender receives the auto-response below instead — encourage staff and guests to respond in the app.">
                                                <Typography variant="caption" color="textSecondary" component="span" sx={{ ml: 1 }}>
                                                    Recipients can't reply here; they get an automatic response.
                                                </Typography>
                                            </Tooltip>
                                        </Grid>
                                        {deliveryMethod.prevent_replies && (
                                            <Grid item xs={12} sm={8}>
                                                <TextField
                                                    disabled={!hasWritePerm}
                                                    name="prevent_replies_message"
                                                    label="Auto-response when someone replies"
                                                    placeholder="This message does not accept replies. Please use the app to respond, or contact your supervisor."
                                                    value={deliveryMethod.prevent_replies_message || ''}
                                                    onChange={(ev) => setDeliveryMethod((prev: any) => ({ ...prev, prevent_replies_message: ev.target.value }))}
                                                    variant="filled"
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    helperText="Leave blank to use the default message."
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                )}
                                {/* CP-8442: reply on the channel the guest used. Airbnb is deliberately absent: Airbnb notifications mirror every reply into the booking's thread. */}
                                {[DELIVERY_METHOD_WHATSAPP, DELIVERY_METHOD_SMS, DELIVERY_METHOD_EMAIL].includes(deliveryMethod.method) && (
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            disabled={!hasWritePerm}
                                            control={
                                                <Checkbox
                                                    name="only_on_inbound_channel"
                                                    checked={!!deliveryMethod.only_on_inbound_channel}
                                                    onChange={(ev) => onCheckboxChange('only_on_inbound_channel', ev)}
                                                />
                                            }
                                            label="Only send if the guest last wrote on this channel"
                                        />
                                        <Tooltip title="Sends only when the guest's most recent message in this conversation came in on this channel. If they last wrote from the app or another channel, or haven't written at all, this method is skipped. Use it on personal-conversation notifications such as 'User receives a message', and tick it on the WhatsApp, SMS and email methods so replies go back the way the guest wrote in.">
                                            <Typography variant="caption" color="textSecondary" component="span" sx={{ ml: 1 }}>
                                                Replies go back on the channel the guest used.
                                            </Typography>
                                        </Tooltip>
                                    </Grid>
                                )}
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && (
                                    <>
                                        <Grid item container xs={12} spacing={2}>
                                            <Grid item xs={10}>
                                                <HTMLPReviewPopper htmlContent={getCodeEditorValue(cm)} cm={cm} />
                                            </Grid>
                                            <Grid item xs={2} container>
                                                <Grid item xs={12} container justifyContent="flex-end" alignItems="center">
                                                    <Button variant="outlined" onClick={onFormatTemplateClick}>Format template</Button>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                { isFormatting && <LinearProgress/> }
                                            </Grid>
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={12} container>
                                    <Grid container alignItems="center" justifyContent="right" id="search-result-wrapper" spacing={1}
                                        style={{ width: '35%', backgroundColor: '#f0f0f0', border: '1px solid rgba(0, 122, 255, 0.25)', 
                                            paddingRight: '10px', marginRight: '-1px', paddingBottom: '3px', marginLeft: 'auto', display: 'none'
                                        }}>
                                        <Grid item justifyContent="right">
                                            <Typography variant="body2" component="div"><div id='search-result-count'>test</div></Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CodeEditor
                                            id={getDeliveryMethodField()}
                                            name={getDeliveryMethodField()}
                                            defaultValue={deliveryMethod[getDeliveryMethodField()]}
                                            setCm={setCm}
                                            setIsChanged={setIsChanged}
                                        />
                                    </Grid>
                                </Grid>
                                {deliveryMethod.method === DELIVERY_METHOD_EMAIL && (
                                    <>
                                        <Grid item xs={12} container>
                                            {/* <Grid item xs={6}>
                                                <FormControlLabel control={<Checkbox checked={showEmailSignature} onChange={(ev) => setShowEmailSignature((prev) => !prev)} />} label="Add Operator's Signature" />
                                                <Typography>
                                                    {' '}
                                                    (Edit data in <Link onClick={() => history.push('/settings/general')}>General settings</Link>)
                                                </Typography>
                                            </Grid> */}
                                            {/* {showEmailSignature && (
                                                <Grid item xs={6} container justifyContent="flex-end">
                                                    <RemoteAutocomplete
                                                        resource="tour_operator_signature"
                                                        label="Select signature"
                                                        urlSuffix={null}
                                                        variant="filled"
                                                        size="small"
                                                        onChange={onEmailSignatureChange}
                                                        fullWidth
                                                        value={deliveryMethod.email_signature}
                                                        isOptionEqualToValue={(option:any, value:any) => option.id === value.id}
                                                    />
                                                    <div id="display_signature"></div>
                                                </Grid>
                                            )} */}
                                        </Grid>
                                        {/* Attachments */}
                                        <Grid item xs={12} ml={2} mb={-2}>
                                            <Typography fontSize={20} fontWeight={500}>
                                                Attachments
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12} xl={8}>
                                            <List>
                                                <ListItem disablePadding key="email_attach_event_files" alignItems="flex-start" dense>
                                                    <ListItemButton disabled={!hasWritePerm} alignItems="flex-start" onClick={(ev) => onCheckboxChange('email_attach_event_files', ev)}>
                                                        <ListItemIcon>
                                                            <Checkbox name="email_attach_event_files" checked={deliveryMethod.email_attach_event_files} sx={{ paddingTop: 0, paddingLeft: 0 }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Event/calendar invite" secondary="Select this option to embed an event/calendar invite" />
                                                    </ListItemButton>
                                                </ListItem>

                                                <ListItem disablePadding key="email_attach_booking_voucher" alignItems="flex-start" dense>
                                                    <ListItemButton disabled={!hasWritePerm} onClick={(ev) => onCheckboxChange('email_attach_booking_voucher', ev)}>
                                                        <ListItemIcon>
                                                            <Checkbox name="email_attach_booking_voucher" checked={deliveryMethod.email_attach_booking_voucher} sx={{ paddingTop: 0, paddingLeft: 0 }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Booking voucher" secondary="Select this option to attach the voucher provided by the booking system" />
                                                    </ListItemButton>
                                                </ListItem>

                                                <ListItem disablePadding key="email_attach_participant_files" alignItems="flex-start" dense>
                                                    <ListItemButton disabled={!hasWritePerm} onClick={(ev) => onCheckboxChange('email_attach_participant_files', ev)}>
                                                        <ListItemIcon>
                                                            <Checkbox name="email_attach_participant_files" checked={deliveryMethod.email_attach_participant_files} sx={{ paddingTop: 0, paddingLeft: 0 }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Participant files" secondary="Select this option to send files attached to a specific participant's booking (e.g., train tickets)" />
                                                    </ListItemButton>
                                                </ListItem>
                                            </List>

                                            <Divider />

                                            <List>
                                                <ListItem disablePadding key="email_attach_notification_files" alignItems="flex-start" dense>
                                                    <ListItemButton disabled={!hasWritePerm} alignItems="flex-start" onClick={(ev) => onCheckboxChange('email_attach_notification_files', ev)}>
                                                        <ListItemIcon>
                                                            <Checkbox name="email_attach_notification_files" checked={deliveryMethod.email_attach_notification_files} sx={{ paddingTop: 0, paddingLeft: 0 }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Other" secondary="Generic attachments for every participant triggered by this notification" />
                                                    </ListItemButton>
                                                </ListItem>
                                            </List>
                                        </Grid>
                                        {/* maxWidth: at full width, ml={7} pushed the rows (and their trash) past the card below lg. */}
                                        <Grid item xs={12} md={12} xl={8} container spacing={2} ml={7} mt={-3} sx={{ maxWidth: { xs: 'calc(100% - 56px)', xl: '66.666667%' } }}>
                                            {emailAttachments.map((file: any) => (
                                                <Grid item xs={12} key={file.id ?? `new-${file.idx}`} style={{ backgroundColor: '#F5F5F5', height: '48px', borderRadius: '8px', display: 'flex', minWidth: 0 }} ml={2} mt={0.5} p={2} container justifyContent="space-between" alignItems="center" alignContent="center">
                                                    {/* CP-5559: the name opens the file; Replace (blue) beside the trash. */}
                                                    <FileActionRow
                                                        name={file.name}
                                                        file={file.file}
                                                        onReplace={file.id ? () => handleOnReplace(dz, file.id) : undefined}
                                                        onDelete={() => handleFileDelete(file.id)}
                                                        replaceTitle="Replace attachment"
                                                        deleteTitle="Remove attachment"
                                                        disabled={!hasWritePerm}
                                                        actionsAtEnd
                                                        sx={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            ))}
                                            <Grid item xs={12} color="primary">
                                                <input {...dz.getInputProps()} />
                                                <Button
                                                    disabled={!hasWritePerm}
                                                    variant="outlined"
                                                    onClick={() => {
                                                        handleOnReplace(dz);
                                                    }}
                                                >
                                                    <AddIcon fontSize="small"/>&nbsp;Add attachment
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControlLabel disabled={!hasWritePerm} control={<Checkbox checked={showTestEmailDetails} onChange={onSendTestEmailChange} />} label="Send test email" />
                                        </Grid>
                                    </>
                                )}
                                {showTestEmailDetails && (
                                    <Grid item xs={12} container spacing={2}>
                                        <Grid item xs={12}>
                                            <TextField disabled={!hasWritePerm} name={'test_email_address'} label="Test Email" defaultValue={testEmail.email_address} variant="filled" fullWidth onChange={(ev) => setTestEmail((prev) => ({ ...prev, email_address: ev.target.value }))} />
                                        </Grid>
                                        {showTestEmailWarning && (
                                            <Grid item xs={12} p={2} ml={2} mt={2} sx={{ border: '#fa3f33 solid 1px', borderRadius: '8px' }}>
                                                <Typography color="secondary">Please save changes for them to show in the test email</Typography>
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            <TextField disabled={!hasWritePerm} variant="filled" label="Text" fullWidth multiline minRows={4} defaultValue={testEmail.context} onChange={(ev) => setTestEmail((prev) => ({ ...prev, context: ev.target.value }))} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography>
                                                *contact support at{' '}
                                                <a href="mailto:operations@curatedplanet.com" style={{ textDecoration: 'none' }}>
                                                    <Link>Operations@CuratedPlanet.com</Link>
                                                </a>{' '}
                                                for context code to paste here.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button variant="outlined" disabled={!hasWritePerm} onClick={() => handleSendTestEmail()} style={{ borderColor: '#D8D8D8', borderRadius: '8px', outline: 'none' }}>
                                                Send test
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                            <Drawer
                                anchor='right'
                                open={open}
                                onClose={toggleDrawer(false)}
                                slotProps={{backdrop: { style: { backgroundColor: "transparent" } }}}
                                PaperProps={{
                                    sx: {
                                        width: { xs: '100%', sm: 500 },
                                        maxWidth: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    },
                                }}
                            >
                                {tagDictionaryPropertyCount === 0 ? <Typography>No tags found.</Typography> : <SchemaUI schema={tagDictionary} toggleTagDictionary={toggleDrawer(false)} loading={fetchingSchema} handleCopyTagTemplate={handleCopyTagTemplate} />}
                            </Drawer>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem', backgroundColor: '#F5F5F5', minHeight: '60px', alignItems: 'center', padding: '0 1rem' }}>
                <FormActionButtons
                    mode="edit"
                    onSubmit={handleSave}
                    submitDisabled={!hasWritePerm || !canSave || !isChanged}
                    onCancel={() => history.push(`/notifications/${props.data.id}`)}
                />
            </div>
            <DeliveryMethodPreviewDialog
                open={testRenderOpen}
                onClose={() => setTestRenderOpen(false)}
                notificationId={props.data.id}
                deliveryMethodId={deliveryMethod.id}
                methodLabel={delivery_method_type}
                defaultEventCode={props.data.event}
                hasUnsavedChanges={isChanged}
                // Read CodeMirror lazily — it isn't React state, so the editor
                // value at click time is what we want, not what was here on
                // dialog open.
                getFieldOverrides={() => ({
                    email_subject: emailSubject,
                    [messageField]: getCodeEditorValue(cm),
                })}
            />
        </div>
        </FormLicenseeContext.Provider>
    );
};

const DeliveryMethodEdit = (props: any) => {
    const resource = 'notification';
    const routeParams: any = useParams();
    const id = routeParams?.id;
    const { hasPerm } = React.useContext(ContextStore);


    if (!hasPerm(resource, 'read')) {
        return <AccessDeniedView />
    }

    return (
        <RecordDetails resource={resource} id={id} fullResponse>
            {/* @ts-ignore */}
            <RecordDetailsContext.Consumer>{(res) => (res.statusCode === 200 ? <DeliveryMethodEditForm {...props} resource={resource} data={res.data} /> : <NotificationLoading {...props} resource={resource} res={res} />)}</RecordDetailsContext.Consumer>
        </RecordDetails>
    );
};

export default DeliveryMethodEdit;
